import { propClassName } from '@/styles/TextField';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface TextFieldGroupProps extends ComponentProps<'div'> {
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default'>;
  variant?: ClassNameProp<'default'>;
}

export const TextFieldGroupComponent: Component<TextFieldGroupProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const sizeClassName = propClassName('group_size', size, 'default');
  const colorsClassName = propClassName('group_colors', colors, 'primary');
  const variantClassName = propClassName('group_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};
